import PRODUCT_TYPE_INFO from '../definitions/ProductTypeInfo';


/**
 * Maps a PRODUCT_TYPES value to the EN/FR common name for this type of card
 * @param {object} cardInfo
 * @param {string} cardInfo.productType
 * @param {string} language en or fr
 * @return {string} product type’s label text
 */
export default function getCardProductTypeName({ productType }, language) {
    const name = PRODUCT_TYPE_INFO[productType]
        ? PRODUCT_TYPE_INFO[productType][`name_${language}`]
        : undefined;

    if (!name) {
        throw new RangeError(`getCardProductTypeName: Can’t get product name for “${productType}” in “${language}”`);
    }

    return name;
}
